import React, { Component } from 'react';
import {Button, Col, Form, FormControl, FormGroup, InputGroup, Row, Modal} from "react-bootstrap";
import {API} from "aws-amplify";
import validator from "validator";
import ReactGA from "react-ga";
import ReCAPTCHA from "react-google-recaptcha";
import {Link} from "react-router-dom";

export default class HireJasper extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showHireJasperForm: false,
      isLoadingHireJasperButton: false,
      bsClass: 'modal-header modal-header-info',
      modalTitle: 'Contact Jasper Thayer',
      email: '',
      subject: '',
      message: '',
      CAPTCHA: ''
    };
    this._reCaptchaRef = React.createRef();
  }

  componentDidMount(){
    ReactGA.initialize('UA-134679120-1');
    window.fbq('track', 'ViewContent');
  }

  validateHireJasperForm() {
    if (this.props.isAuthenticated) {
      return (
        validator.isLength(this.state.subject, {min:3, max:undefined}) &&
        validator.isLength(this.state.message, {min:6, max:undefined})
      );
    } else {
      return (
        validator.isEmail(this.state.email) &&
        validator.isLength(this.state.subject, {min:3, max:undefined}) &&
        validator.isLength(this.state.message, {min:6, max:undefined}) &&
        this.state.CAPTCHA
      );
    }
  }

  emailValidationState() {
    if (validator.isEmail(this.state.email)) return 'success';
    else if (this.state.email.length > 6 && this.state.email.includes("@")) return 'warning';
    else if (this.state.email.length > 6 && !validator.isEmail(this.state.email)) return 'error';
    return null;
  }

  subjectValidationState() {
    if (this.state.subject.length >= 3) return 'success';
    return null;
  }

  messageValidationState() {
    if (this.state.message.length >= 6) return 'success';
    return null;
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  };

  handleCAPTCHA = value => {
    if (value === null) {
      this.setState({CAPTCHA: ''});
    } else {
      this.setState({CAPTCHA: value});
    }
  };

  handleSubmit = async event => {
    event.preventDefault();
    this.setState({ isLoadingHireJasperButton: true });
    try {
      await API.post("api", "/email", {
        body: {
          email: this.state.email,
          subject: this.state.subject,
          message: this.state.message,
          form: 'hireJasper',
          CAPTCHA: this.state.CAPTCHA
        }
      });
      this.setState({
        email: '',
        subject: '',
        message: '',
        bsClass: 'modal-header modal-header-success',
        modalTitle: "Email Sent"
      });
      window.fbq('track', 'Lead');
      /*this.setState({
        modalTitle: "reCAPTCHA Error!",
        bsClass: 'modal-header modal-header-danger'
      });*/
    } catch (e) {
      this.setState({
        modalTitle: "Error!",
        bsClass: 'modal-header modal-header-danger'
      });
    } finally {
      this.setState({
        CAPTCHA: '',
        isLoadingHireJasperButton: false
      });
    }
  };

  hireJasper = () => {
    ReactGA.modalview('/hirejasper');
    this.setState({showHireJasperForm: true});
  };
  hireJasperClose = () => {this.setState({showHireJasperForm: false});};

  render() {
    return (
      <div>
        <a onClick={this.hireJasper} className="hireJasper">
          Hire Jasper
        </a>

        {/* Contact Modal */}
        <Modal show={this.state.showHireJasperForm} backdrop="static" onHide={this.hireJasperClose}>
          <Modal.Header bsClass={this.state.bsClass} closeButton>
            {this.state.modalTitle === 'Contact Jasper Thayer' && <span>
              <i className="fa fa-envelope fa-fw" aria-hidden="true"/> Contact Jasper Thayer
            </span>}
            {this.state.modalTitle === 'Email Sent' && <span>
              <i className="fa fa-check fa-fw" aria-hidden="true"/> Email Sent
            </span>}
            {this.state.modalTitle === 'Error!' && <span>
              <i className="fa fa-warning fa-fw" aria-hidden="true"/> Error
            </span>}
          </Modal.Header>

          {this.state.modalTitle === 'Email Sent' && <Modal.Body>
            <p>Your email has been sent.</p>
            <p>Jasper will get back to you soon.</p>
          </Modal.Body>}
          {this.state.modalTitle === 'reCAPTCHA Error!' && <Modal.Body>
            <p>reCAPTCHA did not validate on the server! Are you a bot?</p>
          </Modal.Body>}
          {this.state.modalTitle === 'Error!' && <Modal.Body>
            <p>There was a problem sending your email.</p>
            <p>Perhaps your correspondence was not meant to be...</p>
          </Modal.Body>}
          {this.state.modalTitle === 'Contact Jasper Thayer' && <Modal.Body>
            <p>Are you impressed with the amazing work <Link style={{fontWeight:'bold'}} to="/JasperThayer">Jasper Thayer</Link> has done on this site? <b>GOOD!!!</b></p>
            <p>Submit this <b>SERVERLESS</b> contact form if you have an employment opportunity for Jasper.</p>
            <Row>
              <Form onSubmit={this.handleSubmit}>
                {/* Email */}
                {!this.props.isAuthenticated && <Col xs={12} sm={6} id="hireJasperEmail">
                  <FormGroup bsSize="small" style={{marginBottom:5}} validationState={this.emailValidationState()}>
                    <InputGroup>
                      <InputGroup.Addon><i className="fa fa-envelope-o fa-fw" aria-hidden="true"/></InputGroup.Addon>
                      <FormControl
                        autoFocus
                        type="email"
                        id="email"
                        autoComplete="off"
                        placeholder="Your Email"
                        value={this.state.email}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>}

                {/* Email Subject */}
                {!this.props.isAuthenticated && <Col xs={12} sm={6} id="hireJasperSubject"><FormGroup bsSize="small" style={{marginBottom:5}} validationState={this.subjectValidationState()}>
                  <InputGroup>
                    <InputGroup.Addon><i className="fa fa-vcard-o fa-fw" aria-hidden="true"/></InputGroup.Addon>
                    <FormControl
                      type="text"
                      id="subject"
                      autoComplete="off"
                      placeholder="Subject"
                      value={this.state.subject}
                      onChange={this.handleChange}
                    />
                  </InputGroup>
                </FormGroup></Col>}

                {/* Email Subject If Logged In */}
                {this.props.isAuthenticated && <Col xs={12}><FormGroup bsSize="small" style={{marginBottom:5}} validationState={this.subjectValidationState()}>
                  <InputGroup>
                    <InputGroup.Addon><i className="fa fa-vcard-o fa-fw" aria-hidden="true"/></InputGroup.Addon>
                    <FormControl
                      type="text"
                      id="subject"
                      autoComplete="off"
                      placeholder="Subject"
                      value={this.state.subject}
                      onChange={this.handleChange}
                    />
                  </InputGroup>
                </FormGroup></Col>}



                {/* Message */}
                <Col xs={12}>
                  <FormGroup bsSize="small" style={{marginBottom:5}} validationState={this.messageValidationState()}>
                    <InputGroup>
                      <InputGroup.Addon><i className="fa fa-pencil-square-o fa-fw" aria-hidden="true"/></InputGroup.Addon>
                      <FormControl
                        style={{height:'10vh'}}
                        id="message"
                        componentClass="textarea"
                        placeholder="Message"
                        value={this.state.message}
                        onChange={this.handleChange}
                      />
                    </InputGroup>
                  </FormGroup>
                </Col>

                {!this.props.isAuthenticated && <Col xs={12}>
                  <ReCAPTCHA
                    ref={this._reCaptchaRef}
                    sitekey="6Lc3uLUUAAAAABOIMkh6BA4yXwk9KfdbGBEXdoXT"
                    onChange={this.handleCAPTCHA}
                  />
                </Col>}

                {/* Send Message Button */}
                <Col xs={12}>
                  <Button
                    bsStyle={!this.validateHireJasperForm() ? "default" : "success"}
                    bsSize="small"
                    className="LoaderButton"
                    disabled={!this.validateHireJasperForm() || this.state.isLoadingHireJasperButton}
                    style={{marginTop:3}}
                    type="submit"
                    block
                  >
                    {this.state.isLoadingHireJasperButton && <i className="fa fa-refresh fa-fw spinning" aria-hidden="true"/>}
                    {!this.state.isLoadingHireJasperButton && <i className="fa fa-paper-plane-o fa-fw" aria-hidden="true"/>}
                    {!this.state.isLoadingHireJasperButton ? " Send Message" : " Sending Message…"}
                  </Button>
                </Col>
              </Form>
            </Row>
          </Modal.Body>}
        </Modal>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/Marketing/HireJasper.js